// src/routes/shippingRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Shipping from '../pages/shipping/Shipping';
import ProtectedRoute from '../components/global/ProtectedRoute';

const shippingRoutes = (
    <>
        <Route
            path="/shipping"
            element={
                <ProtectedRoute requiredPermission="shipping.manage">
                    <Shipping />
                </ProtectedRoute>
            }
        />
    </>
);

export default shippingRoutes;
